export const BRAND = {
  name: "The Market Place",
  nameJaipur: "The Market Place Jaipur",
  tagline: "To Jaipur. From Jaipur.",
  subTagline: "A Community to Grow In.",
  logo: "/assets/brand/logo-transparent.png",
  logoWhite: "/assets/brand/logo-white.png",
};

export const ZENITH = {
  name: "Zenith Marketing India",
  url: "https://www.zenithmarketingindia.com",
};

export const COLORS = ["#D81B60", "#E2725B", "#1F6F50", "#2FA88A", "#E8A33D", "#3F51B5"];

export const STATS = [
  { value: "400+", label: "Markets Conducted" },
  { value: "1,000+", label: "Businesses Supported" },
  { value: "50,000+", label: "Attendees" },
  { value: "2019", label: "Since" },
];

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Upcoming Markets", path: "/upcoming-market" },
  { label: "Gallery", path: "/gallery" },
  { label: "Sponsor & Collaborate", path: "/sponsor" },
  { label: "Contact", path: "/contact" },
];

export const CONTACT_INFO = {
  email: "themarketplacejaipur@gmail.com",
  phone: "+91 77370 98866",
  instagram: "https://www.instagram.com/tmpjaipur/",
  instagramHandle: "@tmpjaipur",
};

export const UPCOMING_EDITION = {
  name: "September Edition",
  dates: ["Sep 6, 2026", "Sep 20, 2026"],
  dateISO: ["2026-09-06", "2026-09-20"],
  dateRange: "6th & 20th September 2026",
  timing: "6 PM – 10 PM",
  venue: "Swarn Mahal, Hotel Clarks Amer, Jaipur",
  mapUrl: "https://maps.app.goo.gl/qvqN1m5zPMbQrpkC8?g_st=ic",
  entry: "Free entry for all visitors",
  teaser: "Discover new businesses, familiar favourites and the people behind them at the next edition of The Market Place.",
};

export const EDITION_HIGHLIGHTS = [
  { title: "Live Music", icon: "Music" },
  { title: "DIY Activities", icon: "Palette" },
  { title: "Free Kids Play Area", icon: "Baby" },
  { title: "35+ Homegrown Brands", icon: "Store" },
];

// All real event photography — old set (15-25) + new set (1-22) = 33 photos.
export const MARKET_PHOTOS = [
  ...Array.from({ length: 11 }, (_, i) => `/assets/gallery/${i + 15}.jpg`),
  ...Array.from({ length: 22 }, (_, i) => `/assets/market/${i + 1}.jpg`),
];

// Curated picks for section banners (real event photography only)
export const HERO_SLIDES = [
  "/assets/market/9.jpg",
  "/assets/market/17.jpg",
  "/assets/market/8.jpg",
  "/assets/market/18.jpg",
  "/assets/market/10.jpg",
  "/assets/gallery/20.jpg",
];

export const STORY_IMAGE = "/assets/market/13.jpg";
export const DISCOVERY_BANNER = "/assets/market/19.jpg";
export const STATS_BANNER = "/assets/market/6.jpg";
export const SELL_SECTION_IMAGE = "https://customer-assets-cm19k8pv.emergentagent.net/job_stall-booking-hub-2/artifacts/e99t7a66_DSC_2562-2.jpg";
export const UPCOMING_CARD_IMAGE = "/assets/market/15.jpg";
export const CLOSING_BANNER = "/assets/gallery/22.jpg";
export const ABOUT_STORY_IMAGES = ["/assets/market/1.jpg", "/assets/market/3.jpg", "/assets/market/20.jpg"];
export const UPCOMING_BANNER = "/assets/market/11.jpg";
export const BOOKSTALL_BANNER = "/assets/market/16.jpg";
export const SPONSOR_BANNER_IMAGES = ["/assets/market/12.jpg", "/assets/market/14.jpg"];
export const TIMELINE_IMAGES = ["/assets/market/5.jpg", "/assets/market/7.jpg", "/assets/market/22.jpg"];

// Every photo already used as a banner/curated image elsewhere on the site — excluded from the
// Gallery grid below so no photo ever repeats across the website.
const IMAGES_USED_ELSEWHERE = new Set([
  ...HERO_SLIDES, STORY_IMAGE, DISCOVERY_BANNER, STATS_BANNER, SELL_SECTION_IMAGE, UPCOMING_CARD_IMAGE,
  CLOSING_BANNER, ...ABOUT_STORY_IMAGES, UPCOMING_BANNER, BOOKSTALL_BANNER, ...SPONSOR_BANNER_IMAGES, ...TIMELINE_IMAGES,
]);

export const GALLERY_IMAGES = MARKET_PHOTOS.filter((url) => !IMAGES_USED_ELSEWHERE.has(url)).map((url, i) => ({ id: i, url }));

export const FOUNDER = {
  name: "Upasana Bajaj Kumar",
  photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_stall-booking-hub-2/artifacts/6v1cbtmw_Upasna.jpg",
};

export const TOTAL_STALLS = 35;

// Interactive seat-map layout — mirrors the real venue map (outer ring 1-21, inner ring 22-35).
// Grid is 9 columns x 9 rows. Center block (rows 4-6, cols 4-6) is the hall name.
// orientation "h" = wide/landscape table (top & bottom rows), "v" = tall/portrait table (side columns) —
// matches the real 2x6 ft table proportions shown in the venue layout photo.
export const STALL_LAYOUT = [
  { num: 13, col: 3, row: 1, orientation: "h" }, { num: 12, col: 4, row: 1, orientation: "h" }, { num: 11, col: 5, row: 1, orientation: "h" }, { num: 10, col: 6, row: 1, orientation: "h" },
  { num: 9, col: 9, row: 1, orientation: "v" }, { num: 8, col: 9, row: 2, orientation: "v" }, { num: 7, col: 9, row: 3, orientation: "v" }, { num: 6, col: 9, row: 4, orientation: "v" },
  { num: 5, col: 9, row: 5, orientation: "v" }, { num: 4, col: 9, row: 6, orientation: "v" }, { num: 3, col: 9, row: 7, orientation: "v" },
  { num: 14, col: 1, row: 1, orientation: "v" }, { num: 15, col: 1, row: 2, orientation: "v" }, { num: 16, col: 1, row: 3, orientation: "v" }, { num: 17, col: 1, row: 4, orientation: "v" },
  { num: 18, col: 1, row: 5, orientation: "v" }, { num: 19, col: 1, row: 6, orientation: "v" },
  { num: 20, col: 1, row: 9, orientation: "h" }, { num: 21, col: 2, row: 9, orientation: "h" }, { num: 1, col: 5, row: 9, orientation: "h" }, { num: 2, col: 6, row: 9, orientation: "h" },
  { num: 29, col: 4, row: 3, orientation: "h" }, { num: 28, col: 5, row: 3, orientation: "h" },
  { num: 27, col: 7, row: 3, orientation: "v" }, { num: 26, col: 7, row: 4, orientation: "v" }, { num: 25, col: 7, row: 5, orientation: "v" }, { num: 24, col: 7, row: 6, orientation: "v" }, { num: 23, col: 7, row: 7, orientation: "v" },
  { num: 30, col: 3, row: 3, orientation: "v" }, { num: 31, col: 3, row: 4, orientation: "v" }, { num: 32, col: 3, row: 5, orientation: "v" }, { num: 33, col: 3, row: 6, orientation: "v" }, { num: 34, col: 3, row: 7, orientation: "v" },
  { num: 35, col: 4, row: 7, orientation: "h" }, { num: 22, col: 5, row: 7, orientation: "h" },
];

export const ENTRY_EXIT = { col: 3, row: 9, colSpan: 2 };

// Pricing — simple, per stall per day. No bundle discounts.
export const PRICE_PER_DAY = 4200;
export const ADDONS = {
  electricity: { label: "Electrical Connection", price: 500 },
  extraTable: { label: "Extra Table", price: 2400 },
};

export const STALL_HALL_FEATURES = [
  { title: "Indoor Hall", icon: "Building2" },
  { title: "Air Conditioned", icon: "Wind" },
  { title: "2x6 ft Table, 2 Chairs & Cloth", icon: "Armchair" },
];

// Home — Built for Discovery
export const DISCOVERY_CATEGORIES = [
  { title: "Clothing", icon: "Shirt" },
  { title: "Jewellery & Accessories", icon: "Gem" },
  { title: "Food & Gourmet", icon: "UtensilsCrossed" },
  { title: "Home & Décor", icon: "Home" },
  { title: "Beauty & Wellness", icon: "Sparkles" },
  { title: "Gifting", icon: "Gift" },
  { title: "Kids & Lifestyle", icon: "Baby" },
  { title: "Organic & Sustainable Products", icon: "Leaf" },
  { title: "Independent Makers", icon: "Hammer" },
];

// About — What We Stand For
export const PILLARS = [
  { title: "Community", icon: "Users", desc: "Business becomes stronger when entrepreneurs have people around them who understand the journey." },
  { title: "Opportunity", icon: "Rocket", desc: "Every market should create genuine visibility, interaction and commercial opportunity." },
  { title: "Inclusion", icon: "HeartHandshake", desc: "A first-time entrepreneur deserves the same warmth and encouragement as a business owner with decades of experience." },
  { title: "Trust", icon: "ShieldCheck", desc: "Our relationships have been built through consistency, transparency and doing things the right way." },
  { title: "Growth", icon: "Sprout", desc: "Every market creates momentum that helps businesses grow" },
];

export const TIMELINE = [
  { year: "2019", title: "The journey begins", desc: "The journey begins with organic farmers and homegrown businesses.", image: "/assets/market/5.jpg" },
  { year: "COVID Period", title: "The pivot", desc: "The platform pivots to delivery-led selling to keep businesses connected with customers.", image: "https://customer-assets-cm19k8pv.emergentagent.net/job_stall-booking-hub-2/artifacts/g949x023_IMG_5722.jpeg" },
  { year: "2023", title: "Becoming The Market Place", desc: "The Market Place expands into a broader platform for Jaipur's homegrown business ecosystem.", image: "/assets/market/7.jpg" },
  { year: "Today", title: "A growing community", desc: "400+ markets, 1,000+ businesses supported and a growing community across Jaipur.", image: "/assets/market/22.jpg" },
];

// Book a Stall
export const WHO_ITS_FOR = [
  "Launching your first product",
  "Taking an Instagram business offline",
  "Building an independent label",
  "Creating products by hand",
  "Running an established local business",
  "Working in sustainable or organic categories",
  "Testing a new concept with real customers",
];

export const PARTICIPATION_OFFERS = [
  { title: "Customer Interaction", icon: "MessageCircle", desc: "Meet the people buying your products and tell your story directly." },
  { title: "Visibility", icon: "Eye", desc: "Put your business in front of an audience that comes with the intent to discover." },
  { title: "Market Feedback", icon: "LineChart", desc: "Understand how customers respond to your products, pricing and presentation." },
  { title: "Sales Opportunity", icon: "ShoppingBag", desc: "Turn discovery into immediate purchases and future customers." },
  { title: "Community", icon: "Users", desc: "Meet entrepreneurs, makers and potential collaborators building alongside you." },
  { title: "Continuity", icon: "RefreshCcw", desc: "Become part of a platform that conducts markets throughout the year rather than a one-time Marketplace." },
];

export const WANT_MORE_OF = [
  "Homegrown Makers", "Young First-Time Entrepreneurs", "Sustainable Businesses",
  "Organic Brands", "Purpose-led Businesses", "Independent Creators", "Original Local Concepts",
];

// Gallery
export const FEATURED_EDITIONS = [
  { title: "Sunday Markets", icon: "Sun", desc: "The recurring format that helped build The Market Place community through consistency." },
  { title: "Night Bazaar", icon: "Moon", desc: "An evening marketplace bringing together shopping, food and discovery in a more experiential setting." },
  { title: "Festive Editions", icon: "PartyPopper", desc: "Season-led markets around gifting, celebration and festive shopping." },
  { title: "Special Collaborations", icon: "Handshake", desc: "Markets created alongside institutions, events and partner platforms." },
];

// Sponsor
export const SPONSOR_AUDIENCE = [
  { title: "Homegrown business owners", icon: "Store" },
  { title: "Young entrepreneurs", icon: "Rocket" },
  { title: "Families", icon: "Users" },
  { title: "Lifestyle consumers", icon: "ShoppingBag" },
  { title: "Independent creators", icon: "Hammer" },
  { title: "Discovery-led shoppers", icon: "Eye" },
  { title: "Local business communities", icon: "Building2" },
];

export const PARTNERSHIP_POSSIBILITIES = [
  { title: "On-ground Branding", icon: "Flag", desc: "Meaningful presence across the market environment." },
  { title: "Experiential Activations", icon: "Sparkles", desc: "Build interactions around your product or brand." },
  { title: "Sampling", icon: "PackageOpen", desc: "Allow visitors to experience products directly." },
  { title: "Category Partnerships", icon: "Layers", desc: "Own a relevant category or experience within the market." },
  { title: "Content Integration", icon: "Camera", desc: "Extend the collaboration across The Market Place's digital communication." },
  { title: "Special Editions", icon: "Star", desc: "Create a market or experience around a shared theme." },
  { title: "Community Collaborations", icon: "Handshake", desc: "Build initiatives specifically for entrepreneurs or participating businesses." },
];

export const PARTNERSHIP_APPROACH = [
  "The partner should gain meaningful visibility and interaction.",
  "The visitor should receive a better experience.",
  "The participating businesses should benefit from the association.",
  "And the collaboration should feel naturally connected to The Market Place rather than simply placed inside it.",
];

export const ENQUIRY_TYPES = [
  "Participating as a Business", "Sponsorship", "Brand Collaboration",
  "Venue Collaboration", "Media / Press", "General Enquiry",
];

export const FAQ_UPCOMING = [
  { q: "Is entry free?", a: "Yes, entry is free for all visitors." },
  { q: "Is parking available?", a: "Yes, parking is available on-site at Swarn Mahal, Hotel Clarks Amer." },
  { q: "Is it pet-friendly?", a: "Yes, The Market Place is pet-friendly — feel free to bring your furry friends along." },
  { q: "What time should I arrive?", a: "The market runs from 6 PM to 10 PM — come anytime through the evening." },
];

export const FAQ_BOOKING = [
  { q: "How does payment work?", a: "Booking is instant — select your stall, pay online and you're confirmed. There's no waiting period or review process." },
  { q: "What is the cancellation policy?", a: "All confirmed stall bookings are non-cancellable and non-refundable. Read our full Booking, Cancellation & Transfer Policy for details." },
  { q: "What's included with my stall?", a: "Every stall includes a 2x6 ft table, 2 chairs and a table cloth, inside an air-conditioned indoor hall." },
  { q: "Can I add an electrical connection or an extra table?", a: "Yes — Electrical Connection (₹500) and an Extra Table (₹2,400) can be added as paid add-ons for any stall during booking." },
];

export const POLICY_LINKS = [
  { id: "booking", label: "Booking & Cancellation Policy" },
  { id: "participation", label: "Stall & Vendor Participation Policy" },
  { id: "terms", label: "Terms & Conditions" },
  { id: "privacy", label: "Privacy Policy" },
];
